import logic from "src/utils/genLogic";
import actions, { ActionTypes } from "./actions";
import { push } from "connected-react-router";
import { Trans } from "@lingui/react";
const apiNamespace = "Skus";

const getSkuLogic = logic(apiNamespace, {
  actionName: ActionTypes.GET_SKU,
});

const getAllSkusLogic = logic(apiNamespace, {
  actionName: ActionTypes.GET_ALL_SKUS,
});

const createSkuLogic = logic(apiNamespace, {
  actionName: ActionTypes.CREATE_SKU,
  successCb: (dispatch) => {
    dispatch(push("/skus/list"));
  },
  showErrorMessage: true,
  errorMessage: <Trans id="there_is_an_error_occurred_try_again_later" />,
  showSuccessMessage: true,
  successMessage: <Trans id="item_added_successfully" />,
});
const editSkuLogic = logic(apiNamespace, {
  actionName: ActionTypes.EDIT_SKU,
  showErrorMessage: true,
  errorMessage: <Trans id="there_is_an_error_occurred_try_again_later" />,
  showSuccessMessage: true,
  successMessage: <Trans id="item_edited_successfully" />,
});
const deleteSkuLogic = logic(apiNamespace, {
  actionName: ActionTypes.DELETE_SKU,
  showErrorMessage: true,
  errorMessage: <Trans id="there_is_an_error_occurred_try_again_later" />,
  showSuccessMessage: true,
  successMessage: <Trans id="item_deleted_successfully" />,
});

export default [
  getSkuLogic,
  getAllSkusLogic,
  createSkuLogic,
  editSkuLogic,
  deleteSkuLogic,
];
